import { featureCollection, feature } from '@turf/helpers';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { getAllPoems, getPoemsByTag, getPoemsByTagsList } from './poemService';
import { MapWheelEvent } from 'mapbox-gl';
import { getCuratedTour } from './curatedService';

export function createRandomRoute(map) {
    const poems = getAllPoems();
    const shuffledPoems = poems.sort(() => 0.5 - Math.random());
    const selectedPoems = shuffledPoems.slice(0, 5);
    const route = generateRoute(map, selectedPoems);
    return {
        route,
        selectedPoems
    }
}

export function createRouteByTag(map, tag) {
    const poems = getPoemsByTag(tag);
    const shuffledPoems = poems.sort(() => 0.5 - Math.random());
    const selectedPoems = shuffledPoems.slice(0, 5);
    const route = generateRoute(map, selectedPoems);
    return {
        route,
        selectedPoems,
        tag
    }
}

export function createRouteByTheme(map, tags) {
    const poems = getPoemsByTagsList(tags);
    const shuffledPoems = poems.sort(() => 0.5 - Math.random());
    const selectedPoems = shuffledPoems.slice(0, 5);
    const route = generateRoute(map, selectedPoems);
    return {
        route,
        selectedPoems,
        tags
    }
}

export function getCuratedWalk(map, name) {
    const selectedPoems = getCuratedTour(name)
    const route = generateRoute(map, selectedPoems);
    return {
        route,
        selectedPoems,
    }
}

export function getAndUpdateUserLocation(map) {
    let interval;
    let me;
    navigator.geolocation.getCurrentPosition(position => {
        me = new mapboxgl.Marker()
            .setLngLat([position.coords.longitude, position.coords.latitude])
            .setPopup(new mapboxgl.Popup().setHTML(`<h1>Here I am!</h1>`))
            .addTo(map);

        interval = setInterval(() => {
            navigator.geolocation.getCurrentPosition(position => {
                if (position && position.coords && me) {
                    me.setLngLat([position.coords.longitude, position.coords.latitude])
                        .setPopup(new mapboxgl.Popup().setHTML(`<h1>Here I am! ${new Date().getTime()}</h1>`));
                }
            });
        }, 1000 * 10)
    });
    return interval;
}

export function updateUserLocation(me) {
    const interval = setInterval(() => {
        navigator.geolocation.getCurrentPosition(position => {
            if (position && position.coords && me) {
                me.setLngLat([position.coords.longitude, position.coords.latitude])
                    .setPopup(new mapboxgl.Popup().setHTML(`<h1>Here I am! ${new Date().getTime()}</h1>`));
            }
        });
    }, 1000 * 10)
    return interval;
}

export function addMarkersToMap(map, poems) {
    const markers = [];

    poems.forEach((poem) => {
        if (!poem.coordinates.includes(',')) return;
        const coOrds = poem.coordinates.split(',');
        const parsed = [parseFloat(coOrds[1]), parseFloat(coOrds[0])]
        const marker = new mapboxgl.Marker()
            .setLngLat(parsed)
            .addTo(map);

        marker.getElement().addEventListener('click', () => {
            console.log(poem);
            const newEvent = new CustomEvent('poem-modal', { detail: poem });
            document.dispatchEvent(newEvent);
            // call modal
        });

        markers.push(marker);
    })
    return markers;
}

export function generateRoute(map, poems) {
    const coordinates = poems.map(poem => poem.coordinates).filter(x => x !== "").map(coord => coord.split(',').reverse().join());
    const coordinatesList = coordinates.join(';');
    const apitoken = 'sk.eyJ1Ijoic2RlZXJlIiwiYSI6ImNrc2pnMWFiZzI4NjgybnAyczRpeGE0MHMifQ.A5idVEg5rKSce1MdYeieJQ'
    fetch(`https://api.mapbox.com/optimized-trips/v1/mapbox/walking/${coordinatesList}?overview=full&steps=true&geometries=geojson&source=first&access_token=${apitoken}`)
        .then(function (response) {
            response.json().then(function (data) {
                console.log(data);

                var routeGeoJSON = featureCollection([feature(data.trips[0].geometry)]);

                map.addSource('route', {
                    type: 'geojson',
                    data: routeGeoJSON
                });

                map.addLayer({
                    id: 'routeline-active',
                    type: 'line',
                    source: 'route',
                    layout: {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    paint: {
                        'line-color': '#3887be',
                        'line-width': [
                            "interpolate",
                            ["linear"],
                            ["zoom"],
                            12, 3,
                            22, 12
                        ]
                    }
                }, 'waterway-label');

                // map.getSource('route')
                //     .setData(routeGeoJSON);

            });


        })
        .catch(function (error) {
            console.log(error)
        });
}